<template lang="pug">
  v-layout(row wrap class="mediumLarge")
    v-flex(md6 lg6)
      .box-global-info(v-if="masivo.producto.toLowerCase().includes('soat')")
        h2
          | Datos de mi seguro
        ul
          ol
            p
              img(:src="icons.numeroPlaca" style="width:16px;margin-left:4px;margin-right: 12px;" alt="numero-placa")
              | N° de placa
            p.omnesMedium.poliza-download
              | {{ masivo.placa }}
              a(:href="'https://www.interseguro.pe/soat/electronico/' + (masivo.numeroPoliza.charAt(0) === '0' ? masivo.numeroPoliza.substr(1) : masivo.numeroPoliza)" style="width:auto;display:flex;" target="_blank" @click="sendEventTracker()")
                img(:src="icons.download" alt="download")
          ol
            p
              img(:src="icons.marcaModelo" style="width:23px" alt="marca-modelo")
              | Marca
            p.omnesMedium {{ masivo.marca }}
          ol
            p
              img(:src="icons.marcaModelo" style="width:23px" alt="marca-modelo")
              | Modelo
            p.omnesMedium {{ masivo.modelo }}
          ol
            p
              img(:src="icons.anho" style="width:23px" alt="año")
              | Año
            p.omnesMedium {{ masivo.fechaFabricacion }}
          ol
            p
              img(:src="icons.uso" style="margin-right: 12px" alt="uso")
              | Uso
            p.omnesMedium {{ masivo.uso }}
          ol
            p
              img(:src="icons.calendar" style="margin-right: 12px" alt="calendar")
              | Vigencia
              span(v-if="getStatusVigenciaSOAT(masivo.fechaFinVigenciaMasivo) === 'POR_VENCER'").label-vigencia.por-vencer Por vencer
              span(v-else-if="getStatusVigenciaSOAT(masivo.fechaFinVigenciaMasivo) === 'VENCIDO'").label-vigencia.vencido Vencido
            p.omnesMedium {{ masivo.fechaInicioVigenciaMasivo }} - {{ masivo.fechaFinVigenciaMasivo }}
          ol
            p
              img(:src="icons.montoPago" style="width:23px;margin-right:7px;" alt="montoPago")
              | Monto pagado
            p.omnesMedium {{ currency }} {{ (Math.round(masivo.primaProgramada * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
      .box-global-info(v-else)
        h2
          | Datos de mi seguro
        ul
          ol
            p
              img(:src="icons.numeroPlaca" style="width:16px;margin-left:4px;margin-right: 12px;" alt="numero-placa")
              | N° de placa
            p.omnesMedium.poliza-download
              | {{ masivo.placa }}
              img(v-if="masivo.codigoProceso && (masivo.codigoProceso || []).length > 0" :src="icons.download" @click="getPDFElectronicPolicy($event)" alt="download")
          ol
            p
              img(:src="icons.marcaModelo" style="width:23px" alt="marca-modelo")
              | Marca
            p.omnesMedium {{ masivo.marca }}
          ol
            p
              img(:src="icons.marcaModelo" style="width:23px" alt="marca-modelo")
              | Modelo
            p.omnesMedium {{ masivo.modelo }}
          ol
            p
              img(:src="icons.anho" style="width:23px" alt="año")
              | Año
            p.omnesMedium {{ masivo.anho }}
          ol
            p
              img(:src="icons.calendar" alt="calendar")
              | Vigencia
            p.omnesMedium {{ masivo.fechaInicioVigenciaMasivo }} - {{ masivo.fechaFinVigenciaMasivo }}
          ol
            p
              img(:src="icons.sumaAsegurada" alt="shield")
              | Suma Asegurada
              //- v-menu(v-model='tooltips.showSumaAsegurada' open-on-hover :close-on-content-click='false' :nudge-top='25' :nudge-right='5' offset-x='')
                template(v-slot:activator='{ on }')
                  img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
                v-card#popover-info
                  span
                    | El monto indicado es la
                    br
                    | suma asegurada por fallecimiento
            p.omnesMedium {{ currency }}  {{ (Math.round(masivo.montoAsegurado * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
          ol
            p
              img(:src="icons.montoPago" alt="moneda")
              | Monto de pago
            p.omnesMedium {{ currency }} {{ (Math.round(masivo.netoPago * 100) / 100).toFixed(2) }}
          ol
            p
              img(:src="icons.frecuenciaPago" alt="calendar")
              | Frecuencia de pago
            p.omnesMedium {{ masivo.frecuenciaPago }}
      //- PARA VEHICULAR Y OTROS PRODUCTOS MASIVOS - MOSTRAR AQUI EL BLOQUE DE CONTACTO
      .box-agente(class="contacto-vehicular")
        h2 Contáctanos
        v-layout(row wrap)
          v-flex(md10 lg10)
            //- p(@click="sendMailTo('servicios@interseguro.com.pe')" style="cursor:pointer")
            p
              img(:src="icons.mensajeAgente" alt="mensajeAgente")
              span Ingresa a nuestra &nbsp;
                a(:href="links.Home" target="_blank" style="text-decoration:none;")
                  b web
                | &nbsp; y conoce nuestros canales digitales
    v-flex(md1 lg1)
    v-flex(md5 lg5)
      //- SEGUN DISEÑO - BLOQUE DE COBERTURAS PARA PRODUCTOS MASIVOS QUE NO SEAN SOAT SE MUESTRAN AQUI
      .box-beneficiarios(v-if="!masivo.producto.toLowerCase().includes('soat')" :class="!masivo.producto.toLowerCase().includes('soat') ? 'coberturas-vehicular' : ''")
        h2
          | Mis coberturas
          v-menu(v-model='tooltips.showBeneficiarios' open-on-hover :close-on-content-click='false' :nudge-top='22' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Detallamos las coberturas
                br
                | que les corresponde a tu póliza vehicular.
        v-layout(row wrap v-for="(cobertura, index) in masivo.coberturas" :key="cobertura.nombre")
          v-flex(md8 lg8 class="name-beneficiario")
            p {{ cobertura.nombre }}
          v-flex(md2 lg2)
          v-flex(md2 lg2 class="percent-beneficiario")
            p.omnesMedium 100 %
      .box-beneficiarios(v-else class="coberturas-vehicular")
        h2
          | Mis coberturas
          v-menu(v-model='tooltips.showBeneficiarios' open-on-hover :close-on-content-click='false' :nudge-top='22' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Detallamos las coberturas
                br
                | que les corresponde a tu póliza SOAT.
        v-layout(row wrap v-for="(cobertura, index) in masivo.coberturasSoat" :key="cobertura.nombre")
          v-flex(md8 lg8 class="name-beneficiario")
            p {{ cobertura.nombre }}
          v-flex(md2 lg2)
          v-flex(md2 lg2 class="percent-beneficiario")
            p.omnesMedium 100 %
      //- COBERTURAS PARA SOAT
      //- .box-beneficiarios(v-else)
        h2
          | Mis coberturas
          v-menu(v-model='tooltips.showBeneficiarios' open-on-hover :close-on-content-click='false' :nudge-top='25' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Detallamos las coberturas
                br
                | que les corresponde de tu póliza soat.
        v-layout(row wrap v-for="(cobertura, index) in masivo.coberturasSoat" :key="cobertura.nombre")
          v-flex(md8 lg8 class="name-beneficiario")
            p {{ cobertura.nombre }}
          v-flex(md2 lg2)
          v-flex(md2 lg2 class="percent-beneficiario")
            p.omnesMedium 100 %
      //- COMPROBANTES ELECTRONICOS
      .box-comprobante-electronico
        h2
          | Comprobante Electrónico
          v-menu(v-model='tooltips.showComprobanteElectronico' open-on-hover :close-on-content-click='false' :nudge-top='29' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Podrás descargar tus comprobantes
                br
                | como boleta, factura, nota de crédito
                br
                | del periodo que elijas.
        v-layout(row wrap)
          v-flex(xs12 sm3 md6 lg6)
            label Documento
            v-select.date-selector(v-model="selectedTypeDoc" hide-details outline :items="items" placeholder='Tipo de comprobante' append-icon="expand_more")
          v-flex(xs6 sm3 md3 lg3)
            label Desde
            v-dialog(ref='dialogStart' v-model='ce.modalStart', :return-value.sync="ce.startDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' v-model="ce.textFieldStartDate" hide-details outline readonly='')
              v-date-picker(v-model="ce.startDate" locale="es-005" :min="ce.minDate" :max="ce.endDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="ce.modalStart = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogStart.save(ce.startDate)") OK
          v-flex(xs6 sm3 md3 lg3)
            label Hasta
            v-dialog(ref='dialogEnd' v-model='ce.modalEnd' :return-value.sync="ce.endDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' v-model="ce.textFieldEndDate" hide-details outline readonly='')
              v-date-picker(v-model="ce.endDate" locale="es-005" :min="ce.minDate" :max="ce.maxDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="ce.modalEnd = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogEnd.save(ce.endDate)") OK
          v-flex(xs12 sm3 md9 lg9)
          v-flex(xs12 sm3 md3 lg3 style="text-align:right")
            v-btn.download-btn-files(type='button' @click="showComprobantesElectronicos()" :disabled="ce.textFieldStartDate === null || ce.textFieldEndDate === null || (selectedTypeDoc === null || selectedTypeDoc === '')" style="margin-top: 1em;") APLICAR
      //- PARA PRODUCTOS SOAT - MOSTRAR EL BLOQUE DE CONTACTO EN ESTE ESPACIO - CUANDO REGRESE EL BLOQUE DE COMPROBANTES, QUITAR EL STYLE
      //- .box-agente(v-if="masivo.producto.toLowerCase().includes('soat')" style="margin-top:0;")
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- MESSAGE COMPROBANTES ELECTRONICOS WHEN SELECT DATE
    v-dialog(v-model="messageLoader" persistent width="500")
      v-card
        v-card-text
          v-layout(wrap row)
            v-flex(md4 lg4)
            v-flex(md4 lg4 style='text-align: center;margin-top: 1em;margin-bottom: 1em')
              img(:src="icons.alerta" alt="alerta")
            v-flex(md4 lg4)
          v-layout(wrap row)
            v-flex(md12)
              p.omnesRegular.message-date-alert-ce
                | Solo podrás descargar los comprobantes desde
                br
                strong 01/2019&nbsp;
                | , si necesitas los comprobantes emitidos
                br
                | antes de esa fechas comunícate al&nbsp;
                br
                strong (01) 500 0000.
          v-layout(wrap row)
            v-flex(md4 lg4)
            v-flex(md4 lg4)
              v-btn.download-btn-files.btn-date-alert-ce.omnesMedium(@click="messageLoader = false") Entendido
            v-flex(md4 lg4)
    //- DIALOG COMPROBANTES ELECTRONICOS
    v-dialog(v-model="loaderCE" persistent width="500")
      v-card.card-comprobantes
        v-card-text
          img#close-btn-ce(:src="icons.close" alt="downloadCe" @click="loaderCE = false")
          h2.omnesMedium
            | Descarga los documentos según
            br
            | las fechas elegidas
          v-layout.wrap__comprobantes(wrap row v-if="listComprobantesElectronicos.length > 0")
            v-flex(md4 lg4 v-if="listComprobantesElectronicos.length === 1")
            v-flex.comprobantes(xs12 sm3 md4 lg4 v-for="(comprobante, index) in listComprobantesElectronicos" :key="comprobante.numero")
              v-layout(row wrap)
                v-flex(md9 lg9)
                  p {{ comprobante.fechaEmision }}
                v-flex(md3 lg3 @click="downloadComprobanteElectronico(comprobante.tipoDocumento, comprobante.serie, comprobante.correlativo, comprobante.historico)" style="cursor:pointer;")
                  img(:src="icons.downloadCe" alt="downloadCe")
            v-flex(md4 lg4 v-if="listComprobantesElectronicos.length === 1")
    //- MODAL DE ERROR - GENERICO PARA MENSAJES
    v-dialog(class="comprobantes-error", v-model="errorModalComprobantes", width="500")
      v-card.sign-in-modal
        figure.text-xs-center
          img(:src="icons.oops" alt="iconError")
        h2.text-blue.text-xs-center Estimado cliente
        p.mt-3.text-xs-center
          span.d-block.g-text-gray-700(style="font-size:16px") En estos momentos no hay comprobantes electrónicos disponibles. Estamos tratando de solucionarlo lo más pronto posible.
        button.transition-all-3.hover-scale(@click="errorModalComprobantes = false") Entendido
</template>

<script>
import electronicVouchers from './../../interfaces/electronicVouchers'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Links from '../../interfaces/links'
import Functionalities from '../../interfaces/functionalities'

export default {
  data () {
    return {
      links: Links,
      // TEMPORAL: Modal para mostrar inestabilidad en el API de Comprobantes
      errorModalComprobantes: false,
      loaderCE: false,
      loader: false,
      currency: '',
      selectedTypeDoc: null,
      isLoadingComprobantes: false,
      hasElectronicPolicy: false,
      items: [],
      listComprobantesElectronicos: [],
      listComrpobantesElectronicosHistoricos: [],
      listComrpobantesElectronicosActuales: [],
      tooltips: {
        showSumaAsegurada: false,
        showBeneficiarios: false,
        showNumeroPoliza: false,
        showEstadoCuenta: false,
        showComprobanteElectronico: false
      },
      icons: {
        visa: require('./../../assets/cambio-cobro/icon-visa.svg'),
        calendar: require('./../../assets/iconsv5/icon-calendar.svg'),
        check: require('./../../assets/iconsv5/icon-check.svg'),
        moneda: require('./../../assets/iconsv5/icon-moneda.svg'),
        question: require('./../../assets/iconsv5/icon-question.svg'),
        shield: require('./../../assets/iconsv5/icon-shield.svg'),
        mensajeAgente: require('./../../assets/vida-icons/icon-correo.svg'),
        download: require('./../../assets/iconsv5/icon-download.svg'),
        marcaModelo: require('./../../assets/iconsv5/icon-marca-modelo.svg'),
        frecuenciaPago: require('./../../assets/iconsv5/icon-frecuencia-pago.svg'),
        montoPago: require('./../../assets/iconsv5/icon-monto-pago.svg'),
        sumaAsegurada: require('./../../assets/iconsv5/icon-suma-asegurada.svg'),
        pagadoHasta: require('./../../assets/iconsv5/icon-pagado-hasta.svg'),
        numeroPlaca: require('./../../assets/iconsv5/icon-numero-placa.svg'),
        uso: require('./../../assets/iconsv5/icon-uso.svg'),
        anho: require('./../../assets/iconsv5/icon-anho.svg'),
        close: require('./../../assets/iconsv5/icon-close-ce.svg'),
        downloadCe: require('./../../assets/iconsv5/icon-download-ce.svg'),
        alerta: require('./../../assets/iconsv5/icon-alerta.svg')
      },
      ce: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      amplitude: {
        events: {
          downloadDocuments: 'Descarga de Documentos'
        }
      },
      messageLoader: false,
      modalEnd: false,
      color: '#1745A8',
      size: '10px'
    }
  },
  props: ['masivo'],
  watch: {
    'ce.startDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let startDateSelected = moment(val + '-01')
      if (startDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldStartDate = moment(this.ce.startDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalStart = false
        this.messageLoader = true
      }
    },
    'ce.endDate': function (val) {
      let minDateAvailable = moment('2018-12-31')
      let endDateSelected = moment(val + '-01')
      if (endDateSelected.isAfter(minDateAvailable)) {
        this.ce.textFieldEndDate = moment(this.ce.endDate).locale('es').format('MMM-YYYY').split('.').join('')
      } else {
        this.ce.modalEnd = false
        this.messageLoader = true
      }
    }
  },
  methods: {
    ...mapActions('user', ['checkJWT', 'getPDFPolizaElectronica', 'getElectronicDocuments', 'downloadComprobante', 'downloadComprobanteLegacy', 'getComprobantes']),
    ...mapActions('event', ['eventLog']),
    async getPDFElectronicPolicy (evt) {
      const self = this
      evt.preventDefault()
      if (!Functionalities.isAvailable(Functionalities.masivos.DESCARGA_POLIZA, self.functionsRules, self, self.guaranteed.producto)) {
        return
      }
      this.loader = true
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'DPE',
        category: 'Zona Privada',
        action: 'PolizaElectronica',
        label: 'Descarga de Póliza Electrónica'
      })
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.masivo.oriProducto === null) {
        if (this.masivo.modalidad === null) {
          productoConsultado = this.masivo.producto
        } else {
          productoConsultado = this.masivo.modalidad
        }
      } else {
        productoConsultado = this.masivo.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Poliza ' + productoConsultado
            // 'Producto Consultado': productoConsultado
          }
        )
      await this.getPdfPoliza({numPoliza: this.masivo.numeroPoliza, makeDownload: true}, this.masivo.codigoProceso)
    },
    async getPdfPoliza (data, codigosProceso) {
      let downloaded = false
      for (let x = 0; x < codigosProceso.length && !downloaded; x++) {
        try {
          const res = await this.getPDFPolizaElectronica({...data, codProceso: codigosProceso[x]})
          if (res.status === 204) {
            this.loader = false
            if (x === codigosProceso.length - 1) {
              this.$swal({
                title: 'Comunicado',
                text: 'Lamentamos las molestias, esta póliza aún no está disponible en formato electrónico. Estamos trabajando para ofrecerla lo antes posible.',
                confirmButtonText: 'Entendido'
              })
            }
          } else {
            this.loader = false
            downloaded = true
          }
        } catch (error) {
          console.log(error)
          if (x === codigosProceso.length - 1) {
            this.loader = false
          }
        }
        /* .then(res => {
            // HTTP RESPONSE: NO CONTENT
          })
          .catch(() => {
            if (x === codigosProceso.length - 1) {
              this.loader = false
            }
          })
        */
      }
    },
    sendMailTo (agent) {
      var mail = document.createElement('a')
      mail.href = 'mailto:' + agent
      mail.click()
    },
    showComprobantesElectronicos () {
      let self = this
      const nombreProducto = this.masivo.nombreProducto || this.masivo.producto
      if (!Functionalities.isAvailable(Functionalities.masivos.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.listComrpobantesElectronicosActuales.length < 1) {
        this.errorModalComprobantes = true
      }
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mi seguros - Comprobante electrónico',
        label: 'Seleccionar botón - Aplicar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mi seguros - Comprobante electrónico',
        CTA: 'Seleccionar botón - Aplicar'
      })
      if (self.ce.startDate !== null && self.ce.endDate !== null && self.selectedTypeDoc !== null) {
        this.loader = true
        // LIMPIANDO LOS COMPROBANTES
        this.listComprobantesElectronicos = []
        let startDate = moment(self.ce.startDate + '-01')
        let endDate = moment(self.ce.endDate + '-01').endOf('month')
        // COMPROBANTES ELECTRONICOS VERIFICAR QUE TIPOS TIENE (HISTORICOS O RECIENTES)
        if (self.selectedTypeDoc.includes('PP') || self.selectedTypeDoc.includes('PESC')) {
          let documents = self.listComrpobantesElectronicosHistoricos
          let selectedTypeDoc = self.selectedTypeDoc.split('.')[0]
          for (let index = 0; index < documents.length; index++) {
            let arrFechaEmisionPaper = documents[index].fechaEmision.split(' ')[0].split('/')
            let fechaEmisionPaper = arrFechaEmisionPaper[2] + '-' + arrFechaEmisionPaper[1] + '-' + arrFechaEmisionPaper[0]
            let fechaEmision = moment(fechaEmisionPaper)
            if (fechaEmision.isBetween(startDate, endDate) && (selectedTypeDoc === documents[index].tipoComprobante)) {
              let fechaEmisionFormat = moment(fechaEmisionPaper, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
              fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
              let serie = ''
              switch (documents[index].tipoComprobante) {
              case 'FAC':
                serie = '01'
                break
              case 'B/V':
                serie = '03'
                break
              default:
                serie = '07'
                break
              }
              let hash = {
                fechaEmision: fechaEmisionFormat,
                tipoDocumento: documents[index].tipoComprobante,
                serie: serie,
                correlativo: documents[index].secuencial,
                historico: true
              }
              this.listComprobantesElectronicos.push(hash)
            }
          }
        }
        // CONDICIONAL PARA CUBRIR TODOS LOS COMPROBANTES
        if (self.selectedTypeDoc.includes('ESC') || self.selectedTypeDoc.includes('PESC')) {
          let selectedTypeDoc = ''
          if (self.selectedTypeDoc.includes('PESC')) {
            selectedTypeDoc = self.selectedTypeDoc.split('.')[1]
          } else {
            selectedTypeDoc = self.selectedTypeDoc.split('.')[0]
          }
          if (this.listComrpobantesElectronicosActuales.length > 0) {
            let documents = this.listComrpobantesElectronicosActuales
            // POBLANDO LOS COMPROBANTES
            for (let index = 0; index < documents.length; index++) {
              let fechaEmision = moment(documents[index].fechaEmision)
              if (fechaEmision.isBetween(startDate, endDate) && (selectedTypeDoc === documents[index].tipoComprobante)) {
                let fechaEmisionFormat = moment(documents[index].fechaEmision, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
                fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
                let hash = {
                  fechaEmision: fechaEmisionFormat,
                  tipoDocumento: documents[index].tipoComprobante,
                  serie: documents[index].serie,
                  correlativo: documents[index].numero,
                  historico: false
                }
                this.listComprobantesElectronicos.push(hash)
              }
            }
            this.loader = false
            this.loaderCE = true
          } else {
            this.loader = false
          }
        }
        this.loader = false
        this.loaderCE = true
      } else {
        self.$swal({
          title: 'Estimado cliente',
          text: 'Debe completar la información para buscar sus comprobantes electrónicos.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    downloadComprobanteElectronico (tipoComprobante, serie, numero, esHistorico) {
      const nombreProducto = this.masivo.nombreProducto || this.masivo.producto
      if (!Functionalities.isAvailable(Functionalities.masivos.COMPROBANTES, this.functionsRules, this, nombreProducto)) {
        return
      }
      this.loader = true
      let hash = {
        tipoDocumento: tipoComprobante,
        serie: serie,
        correlativo: numero,
        producto: this.masivo.oriProducto || this.masivo.producto,
        grupoProducto: this.masivo.ramo.toUpperCase(),
        numeroPoliza: this.masivo.numeroPoliza
      }
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'Descargas Comprobantes Elec.',
        category: 'Zona Privada',
        action: 'ComprobantesElectronicos',
        label: 'Descarga de Comprobantes Electrónicos'
      })
      // TRACK EVENT - AMPLITUDE
      var productoConsultado = ''
      if (this.masivo.oriProducto === null) {
        if (this.masivo.modalidad === null) {
          productoConsultado = this.masivo.producto
        } else {
          productoConsultado = this.masivo.modalidad
        }
      } else {
        productoConsultado = this.masivo.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Comprobantes Electrónicos',
            'Producto Consultado': productoConsultado,
            'Meses consultados': [this.ce.startDate.split('-')[1], this.ce.endDate.split('-')[1]]
          }
        )
      const callbackEventLog = (omitEvent) => {
        if (!omitEvent) {
          this.eventLog({
            categoria: 'Documentos',
            nombre: 'Descarga Comprobantes/Boletas',
            datos: hash
          })
        }
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Comprobante',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (esHistorico) {
        hash.Tipo = 'histórico'
        let xml = {
          tipoDoc: serie,
          folio: numero
        }
        this.downloadComprobanteLegacy(xml)
          .then(res => {
            this.loader = false
            hash.Estado = 'Exitoso'
            hash.respuesta = res.data
            hash.statusCode = res.status
            callbackEventLog()
          })
          .catch((err) => {
            hash.error = err.response.data
            hash.statusCode = err.response.status
            this.loader = false
            callbackEventLog()
          })
      } else {
        this.downloadComprobante(hash)
          .then((res) => {
            this.loader = false
            callbackEventLog(true)
          })
          .catch((err) => {
            this.loader = false
            if (err.data.codigoRespuesta === '99') {
              this.$swal({
                title: 'Estimado cliente',
                text: 'El Comprobante de Pago Electrónico ' + numero + ' , especificado no está registrado o no se encuentra en estado ACEPTADO.',
                confirmButtonText: 'Entendido'
              })
            } else {
              callbackEventLog(true)
            }
          })
      }
    },
    sendEventTracker () {
      const self = this
      // TRACK EVENT - AMPLITUDE
      /*
      let productoConsultado = ''
      if (this.masivo.oriProducto === null) {
        if (this.masivo.modalidad === null) {
          productoConsultado = this.masivo.producto
        } else {
          productoConsultado = this.masivo.modalidad
        }
      } else {
        productoConsultado = this.masivo.oriProducto
      }
      */
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Poliza SOAT'
            // 'Producto Consultado': productoConsultado
          }
        )
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'Poliza SOAT Electronica',
        category: 'Zona Privada',
        action: 'PolizaSoatElectronica',
        label: 'Descarga de Póliza SOAT Electronica'
      })
      this.eventLog({
        categoria: 'Documentos',
        nombre: 'Descarga póliza electrónica',
        datos: {
          producto: self.masivo.oriProducto,
          grupoProducto: self.masivo.ramo.toUpperCase(),
          numeroPoliza: this.masivo.numeroPoliza,
          Estado: 'Exitoso'
        }
      })
    },
    closeModalMasivo () {
      // HIDE SUB-NAV
      this.$root.$emit('hideMasivo', {})
    },
    getStatusVigenciaSOAT (fechaVencimiento) {
      let dia, mes, anio
      if (fechaVencimiento.split('-')[2] !== undefined) {
        let split = fechaVencimiento.split('-')
        dia = parseInt(split[2])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[0])
      } else {
        let split = fechaVencimiento.split('/')
        dia = parseInt(split[0])
        mes = parseInt(split[1]) - 1
        anio = parseInt(split[2])
      }
      let currentDate = new Date()
      let finVigenciaDate = new Date(anio, mes, dia)
      let diff = (finVigenciaDate - currentDate)
      if (diff < 0) {
        return 'VENCIDO'
      } else {
        const expirationDays = diff / (1000 * 3600 * 24)
        if (expirationDays <= 45) {
          return 'POR_VENCER'
        }
      }
      return ''
    }
  },
  mounted () {
    // WARN: MONEDA de la póliza
    this.currency = this.masivo.primaProgramadaMoneda === 'US DOLAR' ? '$' : 'S/ '
    this.ce.maxDate = moment().format('YYYY-MM')
    let minArrDate = this.masivo.fechaInicioVigenciaMasivo.split('/')
    this.ce.minDate = minArrDate[2] + '-' + minArrDate[1]
    // TMP: Fechas para comprobante electronico
    this.ce.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    this.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')
    // COMPROBANTES ELECTRONICOS HISTORICOS COMO ACTAULES
    this.items = []
    let item = { numeroPoliza: Number(this.masivo.numeroPoliza).toString() }
    let self = this
    /*
    self.getElectronicDocuments(item)
      .then((res) => {
        if (res.data.documentosElectronicos.length > 0) {
          self.listComrpobantesElectronicosHistoricos = res.data.documentosElectronicos
          let arrVouchers = self.listComrpobantesElectronicosHistoricos.map(f => { return f.tipoComprobante })
          let arrTypeDocs = arrVouchers.filter(function (item, index) { return arrVouchers.indexOf(item) >= index })
          for (let index = 0; index < arrTypeDocs.length; index++) {
            switch (arrTypeDocs[index]) {
            case 'FAC':
              self.items.push({text: 'Factura', value: 'FAC.PP'})
              break
            case 'N/C':
              self.items.push({text: 'Nota crédito', value: 'N/C.PP'})
              break
            case 'B/V':
              self.items.push({text: 'Boleta de venta', value: 'B/V.PP'})
              break
            }
          }
        }
      })
    */
    const datosEventLog = {
      producto: self.masivo.oriProducto || self.masivo.producto,
      grupoProducto: self.masivo.ramo.toUpperCase(),
      numeroPoliza: self.masivo.numeroPoliza
    }
    self.getComprobantes(item)
      .then((res) => {
        if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length > 0)) {
          datosEventLog.documentos = res.data.documentos
          datosEventLog.Estado = 'Exitoso'
          self.listComrpobantesElectronicosActuales = res.data.documentos
          let documents = self.listComrpobantesElectronicosActuales
          let arrDocuments = []
          // SE OBTIENE LOS CODIGOS DE SUNAT DE CADA COMPROBANTE
          for (let index = 0; index < documents.length; index++) {
            arrDocuments.push(documents[index].tipoComprobante)
          }
          let arrDocsUniq = arrDocuments.filter(function (item, pos) {
            return arrDocuments.indexOf(item) === pos
          })
          // - this.items.push({ text: 'Tipo de comprobante', value: null })
          arrDocsUniq.forEach(el => {
            for (let j = 0; j < electronicVouchers.length; j++) {
              let noEncontroMatch = true
              // SE HACE MATCH
              if (electronicVouchers[j].codigoSunat === el) {
                // DETECTAR SI YA ESTA REPETIDO DEL LEGACY
                for (let x = 0; x < self.items.length; x++) {
                  if (self.items[x].text === electronicVouchers[j].descripcion) {
                    let newValue = self.items[x].value.split('.')
                    self.items[x].value = newValue[0] + '.' + electronicVouchers[j].codigoSunat + '.PESC'
                    noEncontroMatch = false
                    break
                  }
                }
                if (noEncontroMatch) {
                  self.items.push({ text: electronicVouchers[j].descripcion, value: electronicVouchers[j].codigoSunat + '.ESC' })
                  break
                }
              }
            }
          })
          if (self.items.length === 1) {
            self.selectedTypeDoc = self.items[0].value
          }
        } else if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length === 0)) {
          datosEventLog.error = res.data
          datosEventLog.statusCode = res.status
          datosEventLog.Estado = 'Vacío'
          this.$swal({
            title: 'Hola, ',
            text: 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.',
            confirmButtonText: 'Entendido'
          })
        } else {
          datosEventLog.Estado = 'Error'
          datosEventLog.error = res.data
          datosEventLog.statusCode = res.status
        }
        this.eventLog({
          categoria: 'Documentos',
          nombre: 'Consulta Comprobantes/Boletas',
          datos: datosEventLog
        })
      })
      .catch((err) => {
        datosEventLog.Estado = 'Error'
        datosEventLog.error = err.response
        this.eventLog({
          categoria: 'Documentos',
          nombre: 'Consulta Comprobantes/Boletas',
          datos: datosEventLog
        })
      })
  },
  computed: {
    ...mapGetters('user', ['userInfo', 'functionsRules'])
  },
}
</script>

<style>
/** GLOBAL INFO */
.mediumLarge .box-global-info {
  border: #D8D8D8 1px solid;
  padding: 15px 24px 0px 24px;
}
.mediumLarge .box-global-info ul { padding: 0; }
.mediumLarge .box-global-info ul ol {
  overflow: hidden;
  padding-left: 0;
  border-bottom: 1px solid #D8D8D8;
  padding: 12px 0;
}
.mediumLarge .box-global-info ul ol:last-child { border-bottom: 0; }
.mediumLarge .box-global-info ul ol p {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.mediumLarge .box-global-info ul ol p:first-child { float: left; }
.mediumLarge .box-global-info ul ol p:first-child + p { float: right; }
.mediumLarge .box-global-info ul ol p img {
  margin-right: 9px;
  width: 20px;
}
.mediumLarge .box-global-info ul ol p.poliza-download img {
  margin-right: 0;
  margin-left: 7px;
  width: 24px;
  cursor: pointer;
}
/** BENEFICIARIOS */
.mediumLarge .box-beneficiarios.coberturas-vehicular { margin-top: 0 }
.mediumLarge .box-beneficiarios {
  border: #D8D8D8 1px solid;
  padding: 15px 24px 0px 24px;
  margin: 2em 0;
}
.mediumLarge .box-beneficiarios .layout:last-child {
  margin-bottom: 0.4em !important;
  border-bottom: 0;
}
.mediumLarge .box-beneficiarios .layout {
  border-bottom: 1px solid #D8D8D8;
  padding: 3px 0;
}
.mediumLarge .box-beneficiarios .layout .percent-beneficiario p {
  text-align: right;
}
.mediumLarge .box-beneficiarios .layout .percent-beneficiario p,
.mediumLarge .box-beneficiarios .layout .name-beneficiario p {
  margin-bottom: 0;
}
.mediumLarge .box-beneficiarios .layout .name-beneficiario p { text-transform: lowercase !important; }
.mediumLarge .box-beneficiarios .layout .name-beneficiario p::first-letter { text-transform: uppercase !important; }
/** NUMERO DE POLIZA */
.mediumLarge .box-numero-poliza .layout .flex p {
  border: #D8D8D8 1px solid;
  padding: 0 24px;
  font-family: 'Omnes Medium';
  line-height: 46px;
  height: 46px;
}
/** AGENTE */
.mediumLarge .box-agente.contacto-vehicular { margin: 2em 0; }
.mediumLarge .box-agente,
.mediumLarge .box-comprobante-electronico {
  border: #D8D8D8 1px solid;
  padding: 15px 24px 20px 24px;
  margin-bottom: 1.5em;
}
.mediumLarge .box-agente .layout .flex {
  /* border: #D8D8D8 1px solid; */
  padding: 3px !important;
}
.mediumLarge .box-agente .layout .flex p {
  margin-bottom: 0;
  display: flex;
  font-weight: normal;
  font-family: 'Omnes Medium';
  align-items: center;
}
.mediumLarge .box-agente .layout .flex p img {
  width: 19px;
  margin-right: 12px;
}
/** MEDIO DE PAGO */
.mediumLarge .box-medio-pago h2 {
  color: #0855C4;
  font-weight: normal;
  font-size: 21px;
  margin-bottom: 0.5em;
}
.mediumLarge .box-medio-pago .layout .flex p {
  border: 1px solid #D8D8D8;
  padding: 0 24px;
  font-family: 'Omnes Medium';
  display: flex;
  line-height: 46px;
  height: 46px;
}
/** ESTADO DE CUENTA */
/** COMPROBANTE ELECTRONICO */
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot {
  min-height: 50px;
  border: 1px solid #D8D8D8;
}
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot label { top: 14px; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections { padding-top: 3px; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections input::placeholder { color: rgba(0,0,0,0.87); }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection { margin: 0; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner { margin-top: 12px; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon i {
  color: #0855C4;
  font-size: 30px;
}
/** TOOLTIPS */
#popover-info {
  background-color: var(--text-color);
  padding: 8px 12px 10px 12px;
}
#popover-info span,
#popover-info p {
  color: #FFF;
  font-size: 14px;
}
/** GLOBAL STYLES */
.mediumLarge .flex .box-global-info h2 {
  margin-bottom: 0.5em;
}
.mediumLarge .box-global-info h2,
.mediumLarge .box-beneficiarios h2,
.mediumLarge .box-comprobante-electronico h2,
.mediumLarge .box-numero-poliza h2,
.mediumLarge .box-agente h2,
.mediumLarge .box-beneficiarios h2 {
  display: flex;
  color: #0855C4;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 0.7em;
}
.mediumLarge .box-agente h2 {
  margin-bottom: 0.3em;
}
.mediumLarge .box-beneficiarios h2 img.question-mark-icon,
.mediumLarge .box-comprobante-electronico h2 img.question-mark-icon,
.mediumLarge .box-numero-poliza h2 img.question-mark-icon,
.mediumLarge .box-beneficiarios h2 img.question-mark-icon,
.mediumLarge .box-global-info ul ol p:first-child img.question-mark-icon {
  margin-left: 8px;
}
.mediumLarge .box-numero-poliza,
.mediumLarge .box-medio-pago {
  border-bottom: 1px solid #D8D8D8;
  margin-bottom: 1.5em;
  padding-bottom: 5px;
}
.mediumLarge .box-comprobante-electronico .layout {
  margin-top: 10px;
}
.mediumLarge .box-comprobante-electronico .flex p {
  margin-bottom: 0;
}
.mediumLarge .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-input__prepend-inner {
  padding-right: 8px;
  margin-top: 2px;
  align-self: center;
}
.mediumLarge .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot {
  min-height: 50px;
  border: 1px solid #D8D8D8;
}
.mediumLarge .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-text-field__slot input {
  margin-top: 9px;
  text-align: center;
}
/** MODAL DE COMPROBANTES */
#close-btn-ce {
  cursor: pointer;
  float: right;
}
.card-comprobantes h2 {
  text-align: center;
  clear: both;
  font-size: 21px;
  line-height: 1.2;
  width: 69%;
  margin: 3em auto 2em auto;
}
.card-comprobantes .v-card__text .layout.wrap__comprobantes { margin-bottom: 2em; }
.card-comprobantes .flex.comprobantes .layout {
  border: 2px solid #D8D8D8;
  border-radius: 4px;
}
.card-comprobantes .flex.comprobantes .layout .flex {
  text-align: center;
}
.card-comprobantes .flex.comprobantes .layout .flex p {
  margin-bottom: 0;
  margin: 8px 0;
  border-right: 1px solid #D8D8D8;
  padding: 2px 0;
}
.card-comprobantes .flex.comprobantes .layout .flex img {
  border-bottom: 2px solid var(--fuchsia-color);
  padding-bottom: 3px;
  padding-top: 9px;
  width: 12px;
}
.card-comprobantes .flex.comprobantes .layout .flex:first-child + .flex {
  align-self: center;
}
p.message-date-alert-ce {
  font-size: 15px;
  text-align: center;
}
.v-btn.download-btn-files.btn-date-alert-ce {
  width: 100%;
  padding: 19px 0 17px 0;
  height: 55px;
  margin-bottom: 1.5em;
}
.v-btn.download-btn-files.btn-date-alert-ce .v-btn__content {
  font-size: 18px;
}
span.label-vigencia {
  margin-left: 1em;
  font-weight: bold;
}
span.label-vigencia.por-vencer {
  color: rgb(234, 12, 144);
}
</style>



// WEBPACK FOOTER //
// src/components/masivos/FormDesktopMasivo.vue